import { ITutorialPassos, MensagensPadrao } from '../../../Components/AdicionarAjuda';

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-da-empresa",

    filtroDeRazaoSocial: "campo-razao-social-filtros-da-empresa",
    filtroDeNomeFantasia: "campo-nome-fantasia-filtros-da-empresa",
    filtroDeCNPJ: "campo-cnpj-filtros-da-empresa",
    filtroDeAtivo: "campo-ativo-filtros-da-empresa",

    botaoListar: "botao-listar-empresa",
    botaoAdicionar: "botao-adicionar-empresa",

}

export const Classes = {
    botaoEditar: "botao-editar-empresa",
    botaoDesativar: "botao-desativar-empresa",
}

export const ConsultarEmpresa: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.razaoSocial, target: () => document.getElementById(IDs.filtroDeRazaoSocial)! },
        { ...MensagensPadrao.filtros.nomeFantasia, target: () => document.getElementById(IDs.filtroDeNomeFantasia)! },
        { ...MensagensPadrao.filtros.cnpj, target: () => document.getElementById(IDs.filtroDeCNPJ)! },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarEmpresa: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarEmpresa: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector("." + Classes.botaoEditar)! },
    ]
}

export const DesativarEmpresa: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector("." + Classes.botaoDesativar)! },
    ]
}
